import React from "react";
import { useTranslation } from "react-i18next";
import BusinessTermsContent from "./BusinessTermsContent";

const BusinessTermsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="bg-white py-16 md:py-20">
      <div className="mx-auto max-w-3xl px-4">
        <h1 className="text-3xl font-extrabold text-[#333] md:text-4xl">
          {t("Business Terms & Conditions")}
        </h1>
        <p className="mt-3 text-sm text-gray-400">
          {t("businessTerms.lastUpdated")}
        </p>
        <div className="mt-6">
          <BusinessTermsContent />
        </div>
      </div>
    </div>
  );
};

export default BusinessTermsPage;
